import styles from "../ChooseSubscription/ChooseSubscription.module.scss";
import React from "react";
import { useTranslation } from "next-i18next";

export interface PaymentHeaderProps {
  hasOffers?: boolean;
}

export const PaymentHeader = ({ hasOffers }: PaymentHeaderProps) => {
  const { t } = useTranslation("translations");
  return (
    <>
      <h1 className={styles.title}>
        {t("web_payment_choose_subscription_title", "")}
      </h1>

      <p className={styles.description}>
        {hasOffers
          ? t("web_payment_choose_subscription_description", "")
          : t("web_payment_choose_subscription_error", "")}
      </p>
    </>
  );
};

export default PaymentHeader;
